import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select'
import Modal from 'react-bootstrap/Modal';
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";
import { API_CONSTANTS } from "../../../utils/AppConstants";
import { payslipDetailRequest, updatePayslipPaymentRequest, updatePayslipPaymentRequestStatus } from '../../../redux/payroll/payroll.action'
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserEmployee, numberToWords, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";

const PayslipDetail = props => {
    const dispatch = useDispatch()
    const [isLoading, setLoading] = useState(false)
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector((state) => state.user)
    const { payslipDetailSuccess, payslipDetailError,
        updatePayslipPaymentSuccess, updatePayslipPaymentError, updatePayslipPaymentReqStatus
    } = useSelector(state => state.payroll)
    const { state } = useLocation()
    const [showStatusChangeModal, setShowStatusChangeModal] = useState(false)
    const [selectedStatus, setSelectedStatus] = useState()
    let STATUS_LIST = [
        { key: 'Paid', value: 'Paid' },
        { key: 'Error', value: 'Error' },
        { key: 'Other', value: 'Other' }
    ]
    const [remarks, setRemarks] = useState('')

    useEffect(() => {
        fetchPayslipDetail()
    }, [])

    const fetchPayslipDetail = () => {
        setLoading(true)
        dispatch(payslipDetailRequest(state))
    }

    useEffect(() => {
        if (!isEmpty(payslipDetailSuccess)) {
            setLoading(false)
        } else if (!isEmpty(payslipDetailError)) {
            setLoading(false)
            displayErrorToast(payslipDetailError.message)
        }
    }, [payslipDetailSuccess, payslipDetailError])

    useEffect(() => {
        if (updatePayslipPaymentReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(updatePayslipPaymentSuccess.data?.message)
            fetchPayslipDetail()
        } else if (updatePayslipPaymentReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(updatePayslipPaymentError.message)
        }
        if (updatePayslipPaymentReqStatus?.length) {
            dispatch(updatePayslipPaymentRequestStatus(''))
        }
    }, [updatePayslipPaymentSuccess, updatePayslipPaymentError, updatePayslipPaymentReqStatus])

    const isPermissionAllowed = () => {
        return checkFunctionalityPermission(user, PERMISSION_TYPE.PAYROLL, PERMISSION_SUB_TYPE.PAYROLL.MANAGE_EMPLOYEE_PAYROLL, employeeSelectedBusiness, employeeSelectedLocation)
    }

    const handleUpdatePaymentClick = () => {
        setShowStatusChangeModal(true)
    }

    const handleUpdateStatusSubmitClick = () => {
        if (isEmpty(selectedStatus)) {
            displayErrorToast('Status not selected')
        } else {
            setLoading(true)
            const data = {
                employeePayrollId: state,
                status: selectedStatus.key,
                remarks: remarks
            }
            dispatch(updatePayslipPaymentRequest(data))
            setShowStatusChangeModal(false)
        }
    }

    const showButton = () => {
        if (isEmpty(payslipDetailSuccess)) {
            return false
        }
        if (isLoggedInUserEmployee(user) && parseFloat(payslipDetailSuccess.data.employeeId) === parseFloat(user.data.userDetails.employeeId)) {
            return false
        }
        return true
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Payslip Details' />
                {!isEmpty(payslipDetailSuccess) && !isEmpty(payslipDetailSuccess.data) && <CommonFormBorder>
                    <div className="nps-pp-label">Provisional Payslip Calculations</div>
                    <div className="nps-pp-month-label">{payslipDetailSuccess.data.month}, {payslipDetailSuccess.data.year}</div>
                    <div className="row">
                        <div className="col-sm-6 nps-pp-container">
                            <div className="nps-pp-type-label">Salary Details</div>
                            <div className="nps-pp-salary-item-row-container">
                                <div className="nps-pp-salary-item-row-item nps-pp-type-item">Basic</div>
                                <div className="nps-pp-salary-item-row-item nps-pp-type-item">{payslipDetailSuccess.data.baseSalary}</div>
                            </div>
                            <div className="nps-pp-salary-item-row-container">
                                <div className="nps-pp-salary-item-row-item nps-pp-type-item">Duration Type</div>
                                <div className="nps-pp-salary-item-row-item nps-pp-type-item">{removeSpecialCharAndChangeToPascal(payslipDetailSuccess.data.salaryType)}</div>
                            </div>
                            <div className="nps-pp-salary-item-row-container">
                                <div className="nps-pp-salary-item-row-item nps-pp-type-item">Working Days</div>
                                <div className="nps-pp-salary-item-row-item nps-pp-type-item">{payslipDetailSuccess.data.meta.presentDays}/{payslipDetailSuccess.data.meta.workingDays}</div>
                            </div>
                            <FormFieldLabel label='Allowances' />
                            {payslipDetailSuccess.data.allowances.map(item => (<div>
                                <div className="nps-pp-salary-item-row-container">
                                    <div className="nps-pp-salary-item-row-item nps-pp-type-item">{item.name}</div>
                                    <div className="nps-pp-salary-item-row-item nps-pp-type-item">{item.amount} {item.taxable ? 'Taxable' : ''}</div>
                                </div>
                            </div>))}
                        </div>
                        <div className="col-sm-5 nps-pp-container">
                            <div className="nps-pp-type-label">Deductions</div>
                            {payslipDetailSuccess.data.deductions.map(item => (<div>
                                <div className="nps-pp-salary-item-row-container">
                                    <div className="nps-pp-salary-item-row-item nps-pp-type-item">{item.name}</div>
                                    <div className="nps-pp-salary-item-row-item nps-pp-type-item">{item.amount}</div>
                                </div>
                            </div>))}
                            <FormFieldLabel label='Tax Details' />
                            <div className="nps-pp-salary-item-row-container">
                                <div className="nps-pp-salary-item-row-item nps-pp-type-item">Taxable Income</div>
                                <div className="nps-pp-salary-item-row-item nps-pp-type-item">{payslipDetailSuccess.data.taxDetails.taxableIncome}</div>
                            </div>
                            <div className="nps-pp-salary-item-row-container">
                                <div className="nps-pp-salary-item-row-item nps-pp-type-item">Total Tax</div>
                                <div className="nps-pp-salary-item-row-item nps-pp-type-item">{payslipDetailSuccess.data.taxDetails.totalTax}</div>
                            </div>
                        </div>
                    </div>
                    <div className="nps-pp-net-salary">Net Salary: {payslipDetailSuccess.data.netSalary} ({numberToWords(payslipDetailSuccess.data.netSalary)})</div>
                    <div className="nps-pp-payment">Payment Status: {payslipDetailSuccess.data.paymentStatus}</div>
                    {!isEmpty(payslipDetailSuccess.data.paymentRemarks) && <div className="psd-pp-payment-remarks"><span className="psd-pp-payment-remarks-label">Remarks:</span> {payslipDetailSuccess.data.paymentRemarks}</div>}
                    {payslipDetailSuccess.data.paymentStatus === 'Pending' && isPermissionAllowed() && showButton() && <ButtonRow>
                        <CommonButton label='Update Payment Status' onClick={() => { handleUpdatePaymentClick() }} />
                    </ButtonRow>}
                </CommonFormBorder>}
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowStatusChangeModal(false) }}
                show={showStatusChangeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    Update Payment Status
                </Modal.Header>
                <Modal.Body>
                    <FormFieldLabel label='Select Status' />
                    <Select
                        className='select-full-width-no-border'
                        value={selectedStatus}
                        getOptionLabel={e => e.value}
                        getOptionValue={e => e}
                        options={STATUS_LIST}
                        placeholder='Select Status'
                        onChange={e => setSelectedStatus(e)} />
                    {!isEmpty(selectedStatus) && <CommonInputFloatFull
                        type='text'
                        id='remarks'
                        onChange={e => setRemarks(e.target.value)}
                        placeholder='Enter Remarks'
                        value={remarks}
                        multiline={true}
                        rows={4}
                    />
                    }
                    <ButtonRow>
                        <CommonButton label='Update'
                            onClick={() => {
                                handleUpdateStatusSubmitClick()
                            }}
                        />
                    </ButtonRow>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default PayslipDetail